import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-identite',
  templateUrl: './identite.component.html',
  styleUrls: ['./identite.component.css']
})
export class IdentiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
